import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Table } from 'react-bootstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import SweetAlert from 'sweetalert2';
import axios from 'axios';
import { URL_Start, FrontDesk_Cyclotron_URL } from '../../../constant';
import { useLocation, useHistory } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import DataTables from '../commonComponent/DataTable/DataTables';
import NoRecordFounds from '../commonComponent/DataTable/NoRecordFounds';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { set } from 'lodash';


const DrCrapproveamountView = () => {

  const [Name, SetName] = useState("");
  const [InvoiceID, SetInvoiceID] = useState("");
  const [InoviceType, SetInoviceType] = useState("");
  const [NoteNo, SetNoteNo] = useState("");
  const [Narration, SetNarration] = useState("");
  const [DrCrType, SetDrCrType] = useState(""); 
  const [AppliedName, SetAppliedName] = useState("");
  const [TotalAmount, SetTotalAmount] = useState("");
  const [TrDCNRAID, SetTrDCNRAID] = useState("");
  const [DebitCreditNoteAprv, SetDebitCreditNoteAprv] = useState([]);
  const [OrderStatus, setOrderStatus] = useState("");
  const [ReportDisplay, setReportDisplay] = useState("");
  const [ReceiptName, setReceiptName] = useState("");
  
  const [PatientMobile, SetPatientMobile] = useState("");
  const [PatientUHID, SetPatientUHID] = useState("");
  const [PatientDOB, SetPatientDOB] = useState("");
  const [PatientGender, SetPatientGender] = useState("");
  const [Address, SetAddress] = useState("");
  const [CentreName, SetCentreName] = useState("");
  const [Visitno, SetVisitno] = useState("");
  const [VisitDate, SetVisitDate] = useState("");
  const [ReferedBy, SetReferedBy] = useState("");
  const [Registrationdate, SetRegistrationdate] = useState("");
  const [PatientEmailid, SetPatientEmailid] = useState("");
  const [ReferDoctor, SetReferDoctor] = useState("");
  const [TotalAmt, SetTotalAmt] = useState("");
  const [PaidAmt, SetPaidAmt] = useState("");
  const [DiscAmt, SetDiscAmt] = useState("");

  const [ObjdiscountAprvdetails, SetObjdiscountAprvdetails] = useState([]);
  const [orderdetailID, SetOrderDetailID] = useState("0");
  const [Type, SetType] = useState("0");
  const [cardhide, setCardHide] = useState(false);
  const [availLimitFlag, setAvailLimitFlag] = useState("");
  const [viewreqfieldsModal, setViewReqFieldsModal] = useState();
  const [doccrntPageNO, setDocCrntPageNO] = useState(0);
  const [tabledocdata, setTableDocData] = useState([]);

  const location = useLocation();
  let Aprvbutton = useRef();
  let reasontext = useRef();
  const [initiatedBy, setInitiatedBy] = useState("");
  const [approverName, setApproverName] = useState("");
  const [availableLimit, setAvailableLimit] = useState("");
  const [totalLimit, setTotalLimit] = useState("");
  const [IsApprove, setIsApprove] = useState("-1");
  const [remarks, setRemarks] = useState("");
  const [hide, setHide] = useState(false);
  const [visitingid, setVisitingId] = useState("");
  const [invoicegenerated, setInvoiceGenerated] = useState("0");
  const [rejectReason, setRejectReason] = useState("");

  const [fileName, setFileName] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const [Category, setCategory] = useState("");

  useEffect(() => {
    let url = location.search;
    if (url.charAt(0) === "?") { url = url.substring(1) }
    const decryptString = window.atob(url);
    getDrCrNoteapproved(decryptString.split('&')[0].split('=')[1], decryptString.split('&')[1].split('=')[1], decryptString.split('Isaprrove=')[1]);
  }, [])

  const getDrCrNoteapproved = async (TrDCNRAID, type, Isaprrove) => {
    SetOrderDetailID(TrDCNRAID);
    SetTrDCNRAID(TrDCNRAID);
    SetType(type);
    setIsApprove(Isaprrove);
    try {
      let url = URL_Start + 'accounts/GetDRCRapproved/' + TrDCNRAID 
      await axios.get(url).then((response) => {
        const data = response.data;
        if (data.Success) {
          if (data.Data.Name === null && data.Data.PatientUHID === null) {
            SweetAlert.fire("Url details is not valid");
            setCardHide(true);
          }
          else {
            setCardHide(false);
            SetName(data.Data.Name);
            SetInvoiceID(data.Data.InvoiceID);
            SetInoviceType(data.Data.InvoiceType);
            SetNoteNo(data.Data.DrCrNoteNo);
            SetNarration(data.Data.Narration);
            SetDrCrType(data.Data.DrCrType);
            SetAppliedName(data.Data.AppliedName);
            SetTotalAmount(data.Data.TotalAmount);
            setVisitingId(data.Data.VisitingId);
            setRejectReason(data.Data.RejectReason);
            setOrderStatus(data.Data.OrderStatus);
            SetDebitCreditNoteAprv(data.Data.DebitCreditNoteAprvDetailList);
            setVisitingId(data.Data.VisitingID);
            setReportDisplay(data.Data.ReportDisplay);
            setReceiptName(data.Data.ReceiptName);
            setFileName(data.Data.ReceiptName);
            setCategory(data.Data.Category);
          }
        }
        else {
          SetName("");
          
        }
      }).catch(function (error) {
        if (error.response) {
          AxiosError(error.response.status);
        }
      });
    }
    catch (error) {
      SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" });
    }
  }

    const ApproveRejectDrCr = async (flag) => { 
        console.log("flag",flag);
        console.log("reasontext",reasontext.current.value);
        console.log("TrDCNRAID",TrDCNRAID);
    if (flag === "2") {
      if (reasontext.current.value === "") {
        SweetAlert.fire("Reject reason is mandatory");
        return false;
      }
    }
      try {
         const payload = {
            TrDCNRAID  : TrDCNRAID ,
            reasontext: reasontext.current.value,
            flag: flag,
            CreatedBy: localStorage.LoggedInUser
        };
        const url = URL_Start + 'accounts/ApproveRejectDrCrNote';
        await axios.post(url, payload).then((response) => {
            const data = response.data;
           if (response.data && response.data.Success) {
                       SweetAlert.fire({
                           title: "Success",
                           text: "Debit/Credit Note submitted!",
                           icon: "success"
                       }).then(() => {
                           window.close();
                       });
                   } 
                   else if (response.data.ErrorList[0].errorCode === "-2010") {
                       SweetAlert.fire("Error", "Debit Credit note already submitted.", "error");
                   }
        }).catch((error) => {
            SweetAlert.fire("Error", "API call failed.", "error");
        });
    }
    catch (error)
    {
        SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" });
    }   
    }
//   const Approvediscount = async (flag) => {
//     if (flag === "2") {
//       if (reasontext.current.value === "") {
//         SweetAlert.fire("Reject reason is mandatory");
//         return false;
//       }
//     }
//     try {
//       let url;
//       url = URL_Start + 'master/Getdiscountapproved1/' + orderdetailID + '/' + Type + '/' + IsApprove + '/' + flag + '/' + (reasontext.current.value === "" ? "0" : reasontext.current.value)
//       await axios.get(url).then((response) => {
//         const data = response.data;
//         if (Type === "1") {
//           if (data.Data.ApproveReject === "1" || data.Data.ApproveReject === "6") {
//             if (data.Data.FinalOrderStatus === "0" || data.Data.FinalOrderStatus === "6") {
//               SweetAlert.fire({
//                 text: "Approved",
//                 showCancelButton: false,
//                 confirmButtonText: 'Ok',
//                 reverseButtons: true
//               })
//                 .then((result) => {
//                   if (result.value) {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/discounts`, "discount");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                   else {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/discounts`, "discount");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                 })
//             }
//             else {
//               SweetAlert.fire({
//                 text: "Already Approved",
//                 showCancelButton: false,
//                 confirmButtonText: 'Ok',
//                 reverseButtons: true
//               })
//                 .then((result) => {
//                   if (result.value) {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/discounts`, "discount");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                   else {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/discounts`, "discount");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                 })
//             }
//           }
//           else if (data.Data.ApproveReject === "2" || data.Data.ApproveReject === "6") {
//             reasontext.current.value = data.Data.RejectReasonText;
//             if (data.Data.FinalOrderStatus === "0" || data.Data.FinalOrderStatus === "6") {
//               SweetAlert.fire({
//                 text: "Rejected",
//                 showCancelButton: false,
//                 confirmButtonText: 'Ok',
//                 reverseButtons: true
//               })
//                 .then((result) => {
//                   if (result.value) {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/discounts`, "discount");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                   else {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/discounts`, "discount");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                 })
//             }
//             else {
//               SweetAlert.fire({
//                 text: "Already Rejected",
//                 showCancelButton: false,
//                 confirmButtonText: 'Ok',
//                 reverseButtons: true
//               })
//                 .then((result) => {
//                   if (result.value) {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/discounts`, "discount");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                   else {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/discounts`, "discount");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                 })
//             }
//           }
//         }
//         else {
//           if (data.Data.ApproveReject === "1" || data.Data.ApproveReject === "6" || data.Data.ApproveReject === "5") {
//             if (data.Data.FinalOrderStatus === "0" || data.Data.FinalOrderStatus === "6") {
//               SweetAlert.fire({
//                 text: "Approved",
//                 showCancelButton: false,
//                 confirmButtonText: 'Ok',
//                 reverseButtons: true
//               })
//                 .then((result) => {
//                   if (result.value) {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/credits`, "credit");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                   else {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/credits`, "credit");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                 })
//             }
//             else {
//               SweetAlert.fire({
//                 text: "Already Approved",
//                 showCancelButton: false,
//                 confirmButtonText: 'Ok',
//                 reverseButtons: true
//               })
//                 .then((result) => {
//                   if (result.value) {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/credits`, "credit");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                   else {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/credits`, "credit");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                 })
//             }
//           }
//           else if (data.Data.ApproveReject === "2" || data.Data.ApproveReject === "6" || data.Data.ApproveReject === "5") {
//             reasontext.current.value = data.Data.RejectReasonText;
//             if (data.Data.FinalOrderStatus === "0" || data.Data.FinalOrderStatus === "6") {
//               SweetAlert.fire({
//                 text: "Rejected",
//                 showCancelButton: false,
//                 confirmButtonText: 'Ok',
//                 reverseButtons: true
//               })
//                 .then((result) => {
//                   if (result.value) {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/credits`, "credit");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                   else {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/credits`, "credit");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                 })
//             }
//             else {
//               SweetAlert.fire({
//                 text: "Already Rejected",
//                 showCancelButton: false,
//                 confirmButtonText: 'Ok',
//                 reverseButtons: true
//               })
//                 .then((result) => {
//                   if (result.value) {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/credits`, "credit");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                   else {
//                     var win = window.open(`${process.env.PUBLIC_URL}/accounts/credits`, "credit");
//                     win.location.reload();
//                     window.top.close(false);
//                   }
//                 })
//             }
//           }
//         }

//       }).catch(function (error) { if (error.response) { AxiosError(error.response.status); } });
//     } catch (error) { APIError("-3"); }
//   }
    const Printreceipt = (invoiceId, invoiceType) => {
    if (visitingid == "0" || visitingid == "") { }
    else {
      if(invoiceId != "")
      {
        localStorage.removeItem('vId');
        localStorage.setItem('vId', visitingid);
        window.open(`${process.env.PUBLIC_URL}/admin/receipt`, '_blank');
    }
    }
  }
  const AxiosError = async (ErrorCode) => {
    if (ErrorCode === 400) { SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" }) }
    else if (ErrorCode === 401) { SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" }) }
    else if (ErrorCode === 403) { SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" }) }
    else if (ErrorCode === 404) { SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" }) }
    else if (ErrorCode === 500) { SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" }) }
    else if (ErrorCode === 503) { SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" }) }
  }
  const APIError = async (ErrorCode, ErrorMsg) => {
    if (ErrorCode === "-1") { SweetAlert.fire({ title: "Data unavailable", text: "No record found", icon: "error" }) }
    else if (ErrorCode === "-2") { SweetAlert.fire({ title: "API Server Error", text: ErrorMsg, icon: "error" }); }
    else if (ErrorCode === "-3") { SweetAlert.fire({ title: "Runtime Exception", text: "Some error occured! Please try after sometime.", icon: "error" }) }
    else if (ErrorCode === "-4") { SweetAlert.fire({ title: "Wrong Credentials", text: "Please enter correct credentials", icon: "error" }) }
    else if (ErrorCode === "-5") { SweetAlert.fire({ title: "Oops", text: "Data could not be saved, Please try again later", icon: "error" }) }
    else if (ErrorCode === "-6") { SweetAlert.fire({ title: "Failed", text: "Check DB Logs", icon: "error" }) }
    else if (ErrorCode === "-7") { SweetAlert.fire({ title: "Duplicate", text: "Template already exists", icon: "error" }) }
    else if (ErrorCode === "-8") { SweetAlert.fire({ title: "Data unavailable", text: "No record found to import", icon: "error" }) }
    else if (ErrorCode === "-9") { SweetAlert.fire({ title: "LDAP authentication failed", text: ErrorMsg, icon: "error" }) }
    else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }) }
  }
  // const openReceiptFile = (fileName) => {
  //   console.log("fileName:", fileName);
  
  //   if (!fileName) {
  //     SweetAlert.fire("File not available");
  //     return;
  //   }
  
  //   const url = `${URL_Start}accounts/openfile?fileName=${encodeURIComponent(fileName)}`;
  //   console.log("Opening URL:", url);
  
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  const openReceiptFile = async (fileName) => {
  if (!fileName) {
    SweetAlert.fire("File not available");
    return;
  }

  try {
    const checkUrl = `${URL_Start}accounts/openfileexists?fileName=${encodeURIComponent(fileName)}`;
    const response = await axios.get(checkUrl);

    if (response.data === true) {
      const openUrl = `${URL_Start}accounts/openfile?fileName=${encodeURIComponent(fileName)}`;
      window.open(openUrl, "_blank", "noopener,noreferrer");
    } else {
      SweetAlert.fire("File not found");
    }
  } catch (error) {
    SweetAlert.fire("Unable to check file");
  }
};
  return (
    <React.Fragment>
      {
        hide === false ?
          <>
            {DrCrType.toLowerCase()  === 'debit' ?
              <Breadcrumb title="Debit Note Approval" parent="Common" />
              :
              <Breadcrumb title="Credit Note Approval" parent="Common" />
            }
            <Container fluid>
              <Row>
                <Col md={12}>
                  <Card>
                    <Card.Body>
                      <div className="formWrapper">
                        <div className="main">
                          <div className="row mb-2">
                            <div className="col-sm-6">  Name: <span><b>{Name}</b></span></div>
                            <div className="col-sm-6">  Note No: <span><b>{NoteNo}</b></span></div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-sm-6"> Narration:  <span><b>{Narration}</b></span></div>
                            <div className="col-sm-6"> Debit/Credit:  <span><b>{DrCrType}</b></span></div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-sm-6"> Created By:  <span><b>{AppliedName}</b></span></div>
                              {/* <div className="col-sm-6">  { InvoiceID === "" ? "Invoice Type :  " : "Invoice No :  " } <span><b>{InvoiceID === "" ? InoviceType : InvoiceID }</b></span></div> */}
                              <div className="col-sm-6">
                                {InvoiceID === "" ? "Invoice Type : " : "Invoice No : "}
                                <span 
                                  style={{ cursor: "pointer", color: "blue" }} 
                                  onClick={() => Printreceipt(InvoiceID, InoviceType)}
                                >
                                  <b>{InvoiceID === "" ? InoviceType : InvoiceID}</b>
                                </span>
                              </div>
                          </div>
                          {
                            TotalAmount != "0"?
                              <>
                                <div className="row mb-2">
                                  
                                  <div className="col-sm-6"> Status: <span><b>{OrderStatus === "1"
                                    ? "Pending"
                                    : OrderStatus === "2"
                                    ? "Rejected"
                                    : OrderStatus === "3"
                                    ? "Approved"
                                    : ""}</b></span>   </div>
                                
                                <div className="col-sm-6"> {OrderStatus === "2" && (
                                      <span>Reject Reason: <b>{rejectReason}</b></span>
                                    )}</div></div>
                              </> :
                              null
                          }

                          <div className="row mb-2">
                            <div className="col-sm-6"> Report Display:  <span><b>{ReportDisplay}</b></span></div>
                              <div className="col-sm-6"> Receipt Name:  {fileName && (<span
                              onClick={() => openReceiptFile(fileName)}
                              style={{
                                color: "#1a73e8",
                                cursor: "pointer",
                                textDecoration: "underline"
                              }}
                            >
                              View Receipt
                            </span>)}
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-sm-6"> Category:  <span><b>{Category}</b></span></div>
                            <div className="col-sm-6">
                            </div>
                          </div>

                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col"> #</th>
                                <th scope="col"> Item </th>
                                 <th scope="col"> Item Code </th>
                                <th scope="col"> Package </th>
                                <th scope="col"> Qty </th>
                                <th scope="col"> Amount </th>
                                <th scope="col"> Total Amount </th>
                              </tr>
                            </thead>
                            <tbody>
                              {
                                DebitCreditNoteAprv != [] ?
                                  <>
                                    {
                                      DebitCreditNoteAprv.map((d, index) =>
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>{d.Item}</td>
                                          <td>{d.ItemCode}</td>
                                          <td>{d.ispackage.toLowerCase() == "false" ? "Item" : "Package"}</td>
                                          <td>{d.Qty}</td>
                                          <td>{d.Amount}</td>
                                          <td>{d.TotalAmount}</td>
                                        </tr>
                                      )
                                      
                                    }
                                  </>
                                  : null
                              }
                            </tbody>
                            <tfoot>
                              <tr>
                                <th colspan="6" style={{ textAlign: "right" }}>Total Amount</th>
                                <th >{TotalAmount}</th>
                                </tr>       
                            </tfoot>
                          </table>
                          
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </> :
          null
      }
    </React.Fragment>
  )
}

export default DrCrapproveamountView;
